"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
export default function Expertise() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const shows = [{
    title: "Metal Shingles",
    description: "Premium metal shingle systems, including Vicwest North Ridge Slate and Cedar Creek Shake, and Polar stone-coated steel shingles - combining traditional profiles with durable metal construction.",
    ages: "PREMIUM",
    runtime: "LONG-LASTING",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Metal-shingles-roofing.png?v=i4wgm8wqah",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Metal-shingles-roofing.png?v=vgsmriidxjj-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Metal-shingles-roofing.png?v=04nbimp8x187-wvc-sizes",
    rotate: "",
    offset: ""
  }, {
    title: "James Hardie Siding",
    description: "High-performance fiber-cement siding engineered for demanding climates while maintaining a timeless, elegant finish.",
    ages: "DURABLE",
    runtime: "30+ YEARS",
    image: "https://7oo.ca/wp-content/uploads/2026/07/James-hardie-siding-homepage.png?v=891glnoir2",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/James-hardie-siding-homepage.png?v=ueov8cwh6o-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/James-hardie-siding-homepage.png?v=6982ydn9atr-wvc-sizes",
    rotate: "",
    offset: ""
  }, {
    title: "Standing Seam Metal Roofing",
    description: "High-performance standing-seam metal roofing delivering clean architectural lines and dependable, long-lasting weather protection.",
    ages: "MODERN",
    runtime: "WEATHER RESISTANT",
    image: "https://metallineexteriors.ca/wp-content/uploads/2026/08/Standing-Seam-Metal-Roofing_3.png?v=t25bbpii3cf",
    srcset: "https://metallineexteriors.ca/wp-content/uploads/2026/08/Standing-Seam-Metal-Roofing.png?v=juhlsm64cd-wvc-srcset",
    sizes: "https://metallineexteriors.ca/wp-content/uploads/2026/08/Standing-Seam-Metal-Roofing.png?v=2e8ns5t94mp-wvc-sizes",
    rotate: "",
    offset: ""
  }, {
    title: "Stone Veneer",
    description: "Natural stone textures that add depth, character, and timeless appeal to your home’s exterior.",
    ages: "NATURAL",
    runtime: "TIMELESS",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/exterior_stone_veneer.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/exterior_stone_veneer.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/exterior_stone_veneer.png-wvc-sizes",
    rotate: "",
    offset: ""
  }, {
    title: "Acrylic Stucco",
    description: "Durable acrylic stucco finishes offering a clean, contemporary appearance with versatile colour and texture options.",
    ages: "VERSATILE",
    runtime: "DURABLE",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Generated-image-1-1.png?v=2mk54urw2nf",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Generated-image-1-1.png?v=hct2z40jv2-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Generated-image-1-1.png?v=rim9jawgf7j-wvc-sizes",
    rotate: "",
    offset: ""
  }, {
    title: "Aluminum and Metal Siding",
    description: "Versatile aluminum and metal siding delivering lasting durability, low-maintenance performance, and clean modern aesthetics.",
    ages: "MODERN",
    runtime: "DURABLE",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Aluminum-and-metal-siding.png?v=ygiuh82537",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Aluminum-and-metal-siding.png?v=p4hy4nfp1zn-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Aluminum-and-metal-siding.png?v=q5v35n976oh-wvc-sizes",
    rotate: "",
    offset: ""
  }];
  return <section data-section-id="16069" id="our-core-expertise" className="bg-background text-foreground overflow-hidden ![padding:30px_56px_30px_56px]">
      <div className="max-w-[1240px] mx-auto">
        <div ref={introRef} className={`max-w-[680px] mx-auto text-center mb-16 md:mb-24 transition-all duration-[520ms] ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="font-mono text-xs uppercase tracking-[0.12em] text-chart-3">
              Our Core Expertise
            </span>
          </div>
          <h2 className="font-default font-semibold text-foreground leading-[1.02] tracking-tight" style={{
          fontSize: "clamp(2.25rem, 4.4vw, 4rem)"
        }}>
            Premium{" "}
            <span className="relative inline-block">
              <span className="italic text-foreground" style={{
              fontFeatureSettings: '"swsh"'
            }}>
                exterior
              </span>
              <svg className="absolute -inset-x-3 -inset-y-2 w-[calc(100%+1.5rem)] h-[calc(100%+1rem)] pointer-events-none" viewBox="0 0 200 80" preserveAspectRatio="none" aria-hidden="true">
                <path d="M 20 40 Q 10 15, 100 12 Q 195 14, 188 42 Q 185 70, 100 70 Q 15 68, 22 38" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" style={{
                strokeDasharray: 500,
                strokeDashoffset: introVisible ? 0 : 500,
                transition: "stroke-dashoffset 900ms ease-out 400ms"
              }} />
              </svg>
            </span>{" "}
            solutions
          </h2>
          <p className="mt-6 text-base md:text-lg leading-[1.62] text-foreground font-default">
            We specialize in high-end exterior renovations, combining precision engineering with premium materials to protect and elevate your home's value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 auto-rows-fr">
          {shows.map((show, i) => <div key={i} data-index={i} className="group">
              <Card className="relative bg-card text-card-foreground px-6 md:px-8 py-6 md:py-8 transition-all duration-[320ms] ease-out hover:shadow-lg border border-border/50 flex flex-col h-full" style={{
            borderRadius: "4px"
          }}>
                <div className="relative overflow-hidden md:mb-6 aspect-square md:aspect-[5/4]" style={{
              borderRadius: "2px"
            }}>
                  <img src={show.image} data-wvc-srcset={show.srcset} data-wvc-sizes={show.sizes} alt={show.title} loading="lazy" decoding="async" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
                </div>

                <CardContent className="px-0 relative flex flex-col flex-grow">
                  <div className="flex flex-wrap items-center gap-y-1 md:gap-y-2 gap-x-2 mb-6 md:mb-0">
                    <Badge variant="outline" className="font-mono text-[0.7rem] uppercase tracking-[0.12em] border-primary text-primary bg-transparent px-2.5 py-1 rounded-md">
                      {show.ages}
                    </Badge>
                    <span className="font-mono text-[0.7rem] uppercase tracking-[0.12em] text-chart-3">
                      {"·"}
                    </span>
                    <Badge variant="outline" className="font-mono text-[0.7rem] uppercase tracking-[0.12em] border-primary text-primary bg-transparent px-2.5 py-1 rounded-md">
                      {show.runtime}
                    </Badge>
                  </div>

                  <h3 className="font-default font-semibold leading-[1.15] tracking-tight text-foreground mb-4 md:mb-3 relative inline-block" style={{
                fontSize: "clamp(1.5rem, 2.2vw, 2rem)"
              }}>
                    {show.title}
                  </h3>

                  <p className="text-[0.95rem] leading-[1.62] text-foreground/80 font-default mt-4 md:mt-0">
                    {show.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}